import React from "react";
import { graphql } from "gatsby";

import Layout from '../components/layout/layout';
import Hero from "../components/hero/hero";
import SignUp from '../components/sign-up/sign-up';
import Seo from "../components/seo/seo";
import AuthorProfile from "../components/author/author-profile";
import QuickFireQuestions from "../components/author/quick-fire-questions";
import MeetTheTeam from "../components/author/meet-the-team";
import WrittenBy from "../components/author/written-by";

const Author = ({ data, location }) =>  {

  const user = data.wpUser;
  const users = data.allWpUser.nodes;
  const service = data.allWpService.nodes[0];
  const department = data.wpUser.user_department_information.userDepartment;
  const posts = data.allWpPost;

  return(
    <Layout location={ location }>
      <Hero
        content={'meet the '}
        type={'primary'}
        wordList={['expert']}
      />
      <AuthorProfile user={ user } /> 
      <QuickFireQuestions 
        user={ user } 
        department={ department.toLowerCase() } 
      />
      { posts?.edges.length > 0 &&
        <WrittenBy
          user={ user }
          posts={ posts }
        />
      }
      { users.length > 1 &&
        <MeetTheTeam
          department={ department.replace(" ", '-').toLowerCase() }
          service={ service }
          users={ users }
        />
      }
      <SignUp />
    </Layout>
  )
}

export const Head = ({ location, params, data, pageContext }) => {
  const { allWpConnectionType } = data;
  const { seo } = allWpConnectionType.edges[0].node;

  return <Seo seo={seo} pageContext={pageContext} location={location} />
};

export default Author;

export const pageQuery = graphql`
  query ($id: String!, $slug: String!, $department: String!) {
    wpUser(id: {eq: $id}) {
      firstName
      name
      slug
      description
      user_department_information {
        userQuickFireQuestionRepeater {
          userQuickFireQuestionRepeaterContent
          userQuickFireQuestionRepeaterSubheader
        }
        customUserProfileImage {
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
            }
          }
        }
        userDepartment
        userDepartmentPosition
      }
    }
    allWpService(
      sort: {menuOrder: ASC}, 
      filter: {slug: {nin: ["company-updates", "resting-pitch-face"]}, title: {eq: $department}}
    ) {
      nodes {
        title
        services_fields_information {
          fieldServicesFieldsInformationIntro
        }
      }
    }
    allWpUser(
      filter: {user_department_information: {currentAtFlaunt: {eq: true}, userDepartment: {eq: $department}}}
      sort: {user_department_information: {userNumber: ASC}}
    ) {
      nodes {
        name
        id
        slug
        description
        user_department_information {
          currentAtFlaunt
          userDepartmentPosition
          userNumber
          userDepartment
          customUserProfileImage {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
              }
            }
          }
        }
      }
    }
    allWpConnectionType(filter: {author: {node: {slug: {eq: $slug}}}}) {
      edges {
        node {
          seo {
            fullHead
            title
          }
          author {
            node {
              id
              slug
              user_department_information {
                userDepartment
              }
            }
          }
        }
      }
    }
    allWpPost(filter: {author: {node: {slug: {eq: $slug}}}, status: {eq: "publish"}}) {
      edges {
        node {
          id
          slug
          link
          date
          excerpt
          title
          primaryService
          primaryServiceTitle
          servicesTaxonomy {
            nodes {
                databaseId
                id
                name
                slug
            }
          }
          author {
            node {
              slug
            }
          }
          featuredImage {
            node {
                localFile {
                  childImageSharp {
                      gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
                  }
                }
            }
          }
        }
      }
    }
  }
`